export default __webpack_public_path__ + "static/media/viewProduct.1d06fc75.png";